import { GridItem, PageGrid, TextLink, Alert } from '@ads-core/components';

type NotificationProps = {
  status: 'error' | 'pending' | 'success';
  isNetworkProvider: boolean;
};

export const Notification = ({ isNetworkProvider, status }: NotificationProps) => {
  const setNotification = () => {
    switch (true) {
      case status === 'error':
        return <>Er is iets fout gegaan. Probeer het opnieuw of vul een andere postcode in.</>;
      case status !== 'pending' && !isNetworkProvider:
        return (
          <>
            We zien aan uw postcode dat Liander niet uw netbeheerder is. Controleer uw gegevens of
            zoek uw netbeheerder op via{' '}
            <TextLink href="https://www.mijnaansluiting.nl/netbeheerders" target="_blank">
              mijnaansluiting.nl
            </TextLink>
            .
          </>
        );
      default:
        return null;
    }
  };

  return (
    <PageGrid>
      <GridItem columnStart={{ initial: '1', lg: '3' }} columnEnd={{ initial: '-1', lg: '-3' }}>
        <Alert variant={status === 'error' ? 'error' : 'info'}>{setNotification()}</Alert>
      </GridItem>
    </PageGrid>
  );
};
